import LimitIncreaseAddressDocument from "./LimitIncreaseAddressDocument";
import LimitIncreaseSourceOfIncome from "./LimitIncreaseSourceOfIncome";

const JSON_KEY_REGISTRATION_ID = "registration-id";
const JSON_KEY_ADDRESS_DOCUMENTS = "address-documents";
const JSON_KEY_SOURCES_OF_INCOME = "sources-of-income";


export default class LimitIncreaseRequest {

    static createRequest(registrationId, addressDocumentList, sourceOfIncomeList) {
        let jsonData = {};
        jsonData[JSON_KEY_REGISTRATION_ID] = registrationId;

        let addressDocuments = [];
        addressDocumentList.forEach(addressDocument => {
            addressDocuments.push(LimitIncreaseAddressDocument.toJson(addressDocument));
        });
        jsonData[JSON_KEY_ADDRESS_DOCUMENTS] = addressDocuments;

        let sourcesOfIncome = [];
        sourceOfIncomeList.forEach(sourceOfIncome => {
            sourcesOfIncome.push(LimitIncreaseSourceOfIncome.toJson(sourceOfIncome));
        });
        jsonData[JSON_KEY_SOURCES_OF_INCOME] = sourcesOfIncome;

        return jsonData;
    }
}
